module.exports = __webpack_public_path__ + "img/shape16.13633002.png";